import { useContext } from "react";
import styles from "../styles/components/errors.module.css";
import { observer } from "mobx-react-lite";
import { StoreContext } from '..';


function Errors() {
  const {appStore} = useContext(StoreContext);
  const tg = window.Telegram.WebApp;

  return (
    <div className={styles.body}>
        {Object.entries(appStore.errors).map(([key, value]) => {
          const numberKey = Number(key);
          return (
            <div 
              className={value.type === "error" ? styles.error : styles.notify} 
              key={key} 
              onClick={() => {tg.HapticFeedback.impactOccurred('light'); appStore.deleteError(numberKey)}} 
              onAnimationEnd={() => appStore.deleteError(numberKey)}
            >
              <span>{value.text}</span>
            </div>
          );
        }
      )}
    </div>
  );
}

export default observer(Errors);